'use client'

import { Photo } from "@/types/google";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function GoogleSingleImage({ baseUrl, place, googleKey, className, }: { place: string; baseUrl: string; googleKey: string; className?: string; }) {
  const [imagesUrl, setImagesUrl] = useState<Photo[]>([]);

  useEffect(() => {
    const fetchCityImage = async () => {
      try {
        const cacheKey = encodeURIComponent(`${place}`);
        let palceDetail = null;

        if (!palceDetail) {
          // Simulate fetching place_id from an API
          const searchResponse = await fetch(
            `${baseUrl}/places/details?name=${encodeURIComponent(`${place}`)}`,
          ); // Replace with actual API call

          
          const searchData = await searchResponse.json();
          palceDetail = searchData;
          // setWithExpiry(cacheKey, palceDetail, 60 * 60 * 24);
        }
        palceDetail.photos && setImagesUrl(palceDetail.photos);
      } catch (error) {
        console.error("Error fetching city image:", error);
      }
    };

    fetchCityImage();
  }, [baseUrl, place]);

  return (
    <>
      <div className="relative z-0 mx-auto h-full w-full max-w-3xl overflow-hidden bg">
        <div className="flex h-[200px]  transition-transform duration-500 ease-in-out">
          {imagesUrl && imagesUrl[0]?.url ? (
            <div className={`absolute min-w-full h-full cursor-pointer bg-cover bg-center transition-opacity duration-500`}>
              <Image
                className={className}
                src={imagesUrl[0].url}
                alt={`View of ${place}`}
                priority={false}
                width={350}
                height={200}
              />
            </div>
          ) : (
            <div role="status" className={className}>
              <div className="flex h-full w-full items-center justify-center rounded-2xl bg-gray-300 dark:bg-gray-700">
                <svg
                  className="h-12 w-12 text-gray-200 dark:text-gray-600"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 20"
                >
                  <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                  <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                </svg>
              </div>
              <span className="sr-only">Loading...</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};